// extracted by mini-css-extract-plugin
export default {"InputQuestion":"InputQuestion_InputQuestion__ncstH"};